/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { NewEnrollmentRow } from './NewEnrollmentRow';
import {
    NewEnrollmentRowFromJSON,
    NewEnrollmentRowFromJSONTyped,
    NewEnrollmentRowToJSON,
    NewEnrollmentRowToJSONTyped,
} from './NewEnrollmentRow';

/**
 * 
 * @export
 * @interface NewEnrollmentsWidgetData
 */
export interface NewEnrollmentsWidgetData {
    /**
     * 
     * @type {Array<NewEnrollmentRow>}
     * @memberof NewEnrollmentsWidgetData
     */
    items: Array<NewEnrollmentRow>;
}

/**
 * Check if a given object implements the NewEnrollmentsWidgetData interface.
 */
export function instanceOfNewEnrollmentsWidgetData(value: object): value is NewEnrollmentsWidgetData {
    if (!('items' in value) || value['items'] === undefined) return false;
    return true;
}

export function NewEnrollmentsWidgetDataFromJSON(json: any): NewEnrollmentsWidgetData {
    return NewEnrollmentsWidgetDataFromJSONTyped(json, false);
}

export function NewEnrollmentsWidgetDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): NewEnrollmentsWidgetData {
    if (json == null) {
        return json;
    }
    return {
        
        'items': ((json['items'] as Array<any>).map(NewEnrollmentRowFromJSON)),
    };
}

export function NewEnrollmentsWidgetDataToJSON(json: any): NewEnrollmentsWidgetData {
    return NewEnrollmentsWidgetDataToJSONTyped(json, false);
}

export function NewEnrollmentsWidgetDataToJSONTyped(value?: NewEnrollmentsWidgetData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'items': ((value['items'] as Array<any>).map(NewEnrollmentRowToJSON)),
    };
}

